module.exports = "https://www.gc-pro.gnp.com.mx/342aac121e53b0205b465808b81cca77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/question.svg
// module id = 1858
// module chunks = 0